<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests")
                }}<budget-forms-list :curFormSelect="'/form01-123'"
            /></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}. {{ categoryName }}
                </p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="
                        categoryMode &&
                        !isGkkpMode &&
                        !(progress < 100) &&
                        variantAttribute
                    "
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadCategoryData"
                />
                <div class="filter-actions filter-actions-flex">
                    <template v-if="categoryMode">
                        <c-budget-forms-copy-data
                            v-if="
                                !(progress < 100) &&
                                variantAttribute &&
                                header.year < header.cur_year + 2
                            "
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="addItem"
                            v-if="variantAttribute"
                            :disabled="isLoad || isNotSavedBranchExist"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </template>
                    <template v-else>
                        <b-button variant="light" @click="resetModal">
                            <i class="icon icon-keyboard icon-rotate-180"></i>
                            {{ getCommonText("back_to_list") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            v-if="variantAttribute"
                            variant="primary"
                            @click="$refs.formTemplate.addItem()"
                        >
                            <i class="icon icon-plus-circle"></i
                            >{{ getCommonText("add") }}
                        </b-button>
                        <b-button
                            :style="{ minWidth: '110px' }"
                            :disabled="!dataChanged || isLoad"
                            variant="success"
                            @click="prepareForSaveDecodes"
                        >
                            {{ getCommonText("save") }}
                        </b-button>
                    </template>
                </div>
            </div>
        </div>

        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <table class="table" responsive bordered head-variant="light" sticky-header="true" border-collapse="collapse">
                        <thead>
                            <tr>
                                <th>
                                    <div class="text-center">
                                        <b-form-checkbox
                                            v-model="selectAll"
                                            @change="(e) => setIsAllDelete(e)"
                                            :value="true"
                                            :unchecked-value="false"
                                        />
                                    </div>
                                </th>
                                <th v-for="field in tableFields.slice(1,-1)" :key="field.key">{{ field.label }}</th>
                                <th>
                                    <div class="text-center">
                                        <i
                                            :title="getCommonText('del_selected')"
                                            class="icon icon-close table-all-remove"
                                            @click="
                                                deleteItem(
                                                    `${
                                                        selectAll
                                                            ? getCommonText('all_cats')
                                                            : getCommonText('selected_cats')
                                                    }`
                                                )
                                            "
                                        />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td class="td-numbering text-center table-success">1</td>
                                <td class="td-numbering text-center table-danger">2</td>
                                <td class="td-numbering text-center table-info">3</td>
                                <td class="td-numbering text-center table-primary">4</td>
                                <td class="td-numbering text-center table-warning">5</td>
                                <td class="td-numbering text-center table-success">6</td>
                                <td class="td-numbering text-center table-danger">7</td>
                                <td></td>
                            </tr>
                            <template v-for="branch in budgetFormTree">
                                <!---Отрасль --->
                                <tr :key="branch.id" class="branch-row">
                                    <td>
                                        <div class="text-center">
                                            <b-form-checkbox
                                                v-model="branch.itemToDelete"
                                                @change="(e) => onCheckAllBranchClicked(e, branch)"
                                                :value="true"
                                                :unchecked-value="false"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <multiselect 
                                                style="max-width:385px;"
                                                v-if="variantAttribute"
                                                :label="`name_${lng}`"
                                                :title="branch.branch ? branch.branch[`name_${lng}`] : ''"
                                                value="code"
                                                v-model="branch.branch"
                                                :placeholder="getFormText('select_project_branch')"
                                                :options="dictProjectBranchActualDisabled"
                                                @input="(e) => onChangeBranch(e, branch)">
                                        </multiselect>
                                        <div v-else>{{ branch.branch ? branch.branch[`name_${lng}`] : '' }}</div>
                                    </td>
                                    <td></td>
                                    <td class="text-right">
                                        <div>{{ $n(branch.total) }}</div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <span
                                            class="blue pointer underline"
                                            @click="
                                                onAllFilesClick({
                                                    ...branch,
                                                    name_ru: `${branch.branch ? branch.branch['name_ru'] : ''}`,
                                                    name_kk: `${branch.branch ? branch.branch['name_kk'] : ''}`,
                                                })
                                            "
                                            >({{
                                                branch.files ? branch.files.length : 0
                                            }})</span>
                                    </td>
                                    <td></td>
                                </tr>

                                <!---виды кредита --->
                                <tr v-for="item in branch.items" :key="item.id">
                                    <td>
                                        <div class="text-center">
                                            <b-form-checkbox
                                                v-model="item.itemToDelete"
                                                @input="(e) => {onCheckCreditTypeClicked(e, branch)}"
                                                :value="true"
                                                :unchecked-value="false"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div style="display:flex; gap:0.3rem;">
                                            <div>
                                                <button
                                                    class="table-plus"
                                                    :class="{'table-plus-disabled': isDecodeBtnDisabled(item)}"
                                                    v-b-modal.goods-modal
                                                    @click="setCurrCatName({...item, branch_name: branch.branch ? branch.branch[`name_${lng}`] : ''})"
                                                >
                                                    <i  
                                                    class="icon icon-plus-circle" />
                                                </button>
                                            </div>
                                            <div>
                                                <multiselect 
                                                    v-if="variantAttribute"
                                                    style="width:350px;"
                                                    :label="`name_${lng}`"
                                                    :title="item.typeCreditObj ? item.typeCreditObj[`name_${lng}`] : ''"
                                                    value="code"
                                                    v-model="item.typeCreditObj"
                                                    :placeholder="getFormText('select_bc_section')"
                                                    :options="branch.dictBcSectionActual"
                                                    @input="(e) => onChangeCreditType(e, item, branch)">
                                                </multiselect>
                                                <div v-else>{{ item.typeCreditObj ? item.typeCreditObj[`name_${lng}`] : '' }}</div>
                                                <p class="goods-form-val-msg" v-if="!item.type_credit">{{ getCommonText("must_be_filled") }}</p>
                                            </div>  
                                        </div>
                                    </td>
                                    <td>
                                        <div class="column-width-100 bp-category-name">
                                            <p class="goods-form-val-msg" v-if="item.type_credit && !item.period_ru && !item.period_kk">{{ getCommonText("must_be_filled") }}</p>
                                            <div>{{ item["period_" + lng] }}</div>
                                            <i
                                                v-if="variantAttribute && item.type_credit"
                                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                                @click="
                                                    showEditModal(item, 'setPeriodModal')"
                                            ></i>

                                        </div>
                                    </td>
                                    <td class="text-right">{{ $n(item.summa) }}</td>
                                    <td>
                                        <div class="column-width-100 bp-category-name">
                                            <div>{{ item["recipient_" + lng] }}</div>
                                            <i
                                                v-if="variantAttribute && item.type_credit"
                                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                                @click="
                                                    showEditModal(
                                                        item,
                                                        'setRecipientModal'
                                                    )
                                                "
                                            ></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="column-width-100 bp-category-name">
                                            <div>{{ item["purpose_" + lng] }}</div>
                                            <i
                                                v-if="variantAttribute && item.type_credit"
                                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                                @click="
                                                    showEditModal(item, 'setPurposeModal')
                                                "
                                            ></i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="column-width-100 bp-category-name">
                                            <div>{{ item["justif_" + lng] }}</div>
                                            <i
                                                v-if="variantAttribute && item.type_credit"
                                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                                @click="
                                                    showEditModal(item, 'setJustifModal')
                                                "
                                            ></i>
                                        </div>
                                    </td>
                                    <td>
                                        <span
                                            class="blue pointer underline"
                                            @click="
                                                onAllFilesClick({
                                                    ...item,
                                                    name_ru: `${branch.branch ? branch.branch['name_ru'] : ''}. ${item.typeCreditObj['name_ru']}`,
                                                    name_kk: `${branch.branch ? branch.branch['name_kk'] : ''}. ${item.typeCreditObj['name_kk']}`,
                                                })
                                            "
                                            >({{
                                                item.files ? item.files.length : 0
                                            }})</span
                                        >
                                    </td>
                                    <td>
                                        <i
                                            class="icon icon-clear table-remove"
                                            v-if="variantAttribute"
                                            :disabled="deletingCat"
                                            @click="
                                                deleteItem(getCommonText('curr_cat'), item)
                                            "
                                        ></i>
                                    </td>
                                </tr>

                                <!---Добавление вида кредита--->
                                <tr :key="'add_'+branch.id" v-if="branch.branch && branch.dictBcSectionActual.some(itm => !itm.$isDisabled)">
                                    <td colspan="9" class="add-credit-type-row">
                                        <i class="icon icon-plus-circle" style="color:#00a749"/> 
                                        <span class="add-credit-type"
                                            @click="addCredit(branch)">
                                            {{ getFormText('add_credit_type') }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <tr class="total-table-row">
                                <td class="text-right total-table-row" colspan="2">{{ getCommonText("total") }}</td>
                                <td></td>
                                <td class="text-right total-table-row">{{ $n(total) }}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    </b-overlay>
                <div
                    class="table-add"
                    v-if="variantAttribute"
                    :disabled="isLoad || isNotSavedBranchExist"
                >
                    <span @click="addItem"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="isLoad" rounded="sm">
                <form-template12
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lng="lng"
                    :allFiles="allFiles"
                    :isLoad="isLoad"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :dictBcGlobal="dictBcGlobal"
                    :dictBcGlobalActualDisabled="dictBcGlobalActualDisabled"
                    :safeDecimal="safeDecimal"
                    @setIsAllDelete="setIsAllDelete"
                    @deleteRows="deleteRows"
                    @disableSelectedBcGlobal="disableSelectedBcGlobal"
                    @addGetParams="addGetParams"
                ></form-template12>
                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown v-if="isFilterReady"
            ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFileToCategory"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setPeriodModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'period_ru', kk: 'period_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('period')"
            :textareaTitleRu="this.getFormText('period_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('period_textarea_title_kk')"
            :placeHolder="this.getFormText('period_placeholder')"
            :canBeEmpty="isPeriodCanBeEmpty"
            :isDoublesCheckNeeded="false"
            @saveItem="onCatChanged"
        />
        <c-set-b-f-category-name
            ref="setRecipientModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'recipient_ru', kk: 'recipient_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('recipient')"
            :textareaTitleRu="this.getFormText('recipient_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('recipient_textarea_title_kk')"
            :placeHolder="this.getFormText('recipient_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="onCatChanged"
        />
        <c-set-b-f-category-name
            ref="setPurposeModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'purpose_ru', kk: 'purpose_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('purpose')"
            :textareaTitleRu="this.getFormText('purpose_textarea_title_ru')"
            :textareaTitleKk="this.getFormText('purpose_textarea_title_kk')"
            :placeHolder="this.getFormText('purpose_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="onCatChanged"
        />
        <c-set-b-f-category-name
            ref="setJustifModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="{ ru: 'justif_ru', kk: 'justif_kk' }"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('justification')"
            :textareaTitleRu="this.getFormText('justification_title_ru')"
            :textareaTitleKk="this.getFormText('justification_title_kk')"
            :placeHolder="this.getFormText('justification_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="onCatChanged"
        />
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "@/modules/budget-request/mixins/forms-handler-mixin";
import FormTemplate12 from "@/modules/budget-request/components/budget-forms-template12.vue";
import ModalAllFilesManagement from "@/modules/budget-request/components/modal-all-files-management.vue";
import CBudgetFormsCopyData from "@/modules/budget-request/components/budget-forms-copy-data.vue";
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from "@/modules/budget-request/components/budget-forms-data-transfer.vue";
import CSetBFCategoryName from "../components/c-set-bf-category-name.vue";

export default {
    name: "Form513_v2",
    components: {
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        FormTemplate12,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsDataTransfer,
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "513",
                name_kk: "",
                name_ru: "",
            },
            variantAttribute: null,
            budgetForm: [],
            header: null,
            files: null,
            isLoad: false,
            dictProjectBranch: [],
            dictProjectBranchActualDisabled: [],
            dictBcSection: [],
            dictBcGlobal: [],
            dictBcGlobalActualDisabled: [],
            budgetFormTree: [],
            isPeriodCanBeEmpty: false,
        };
    },
    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        },
        goodsData: {
            handler() {
                const hasDataToSave = this.goodsData.some(
                    (gd) => gd.rowToSave
                );
                this.setDataChanged(hasDataToSave);
            },
            deep: true,
        },
    },
    methods: {
        addItem() {
            if (this.isNotSavedBranchExist) return;
            const item = { id: 'branch_' };
            this.$set(item, "branch", null);
            this.$set(item, "items", []);
            this.$set(item, "total", 0);
            this.$set(item, "files", []);
            this.$set(item, "itemToDelete", false);
            this.$set(item, "newBranch", true);
            this.$set(item, "dictBcSectionActual", JSON.parse(JSON.stringify(this.dictBcSectionActual)));
            this.budgetFormTree.push(item);
            this.goodsData.splice(0);
        },

        onChangeBranch(e, branch) {
            this.$set(branch, 'branch', e);
            this.$set(branch, 'id', "branch_" + e.code);
            this.updateBranchCodesInCtredits(branch);
            const itemsToUpdate = branch.items ? branch.items.filter((item) => item.id > 0) : [];
            if (itemsToUpdate.length > 0) {
                this.updateCredits(itemsToUpdate);
            } else {
                this.disableSelectedBranch();
            }
        },

        updateBranchCodesInCtredits(branch) {
            const items = branch.items;
            if (!items || !items.length) return;

            items.forEach((item) => {
                this.$set(item, 'branch', branch.branch.code);
            });
        },

        updateCredits(itemsToUpdate) {
            this.save(itemsToUpdate, true);
        },

        addCredit(branch) {
            if (this.isNotSavedCreditType) return;
            const item = { id: -1 };
            this.$set(item, "branch", branch.branch.code);
            this.$set(item, "type_credit", null);
            this.$set(item, "category_id", this.uuidv4());
            this.$set(item, "summa", 0);
            this.$set(item, "period_ru", "");
            this.$set(item, "period_kk", "");
            this.$set(item, "recipient_ru", "");
            this.$set(item, "recipient_kk", "");
            this.$set(item, "purpose_ru", "");
            this.$set(item, "purpose_kk", "");
            this.$set(item, "justif_ru", "");
            this.$set(item, "justif_kk", "");
            this.$set(item, "newCat", true);
            this.$set(item, "checkForDuplicates", false);
            this.$set(item, "isDataValid", false);
            this.$set(item, "itemToDelete", false);
            branch.items.push(item);
            this.budgetForm.push(item);
        },

       
        addGetParams(item) {
            Object.defineProperty(item, "total", {
                get: () => {
                    const amount = this.safeDecimal(item.amount);
                    const cost = this.safeDecimal(item.cost);
                    const total = amount.mul(cost).div(1000).toDecimalPlaces(2);
                    return total.toNumber();
                },
            });
        },

        onChangeCreditType(e, item, branch) {
            this.$set(item, 'type_credit', e.code);
            this.setDisabledItemsInDictBcSection([branch]);
            this.onCatChanged(item)
        },

        onCatChanged(item) {
            this.save([item], true);
        },

        async save(items, isSaveCat = false) {
            if (items.length === 0) return;
            this.isLoad = true;
            this.setIsCopyRowsBtnVisible(false);
            const data = {
                isSaveCat: isSaveCat,
                values: items,
                header: this.header,
                total: this.total,
            };
            try {
                const response = await fetch("/api-py/save-brform513_v2/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    const result = await response.json();

                    if ("result" in result && result["result"] == "success") {
                        if (isSaveCat) {
                            if ("new_id" in result) {
                                this.$set(items[0], "id", result["new_id"]);
                                const parentBranch = this.budgetFormTree.find(
                                    (br) =>
                                        br.id === `branch_${items[0].branch}`
                                );
                                this.$set(parentBranch, "newBranch", false);
                            }
                            this.disableSelectedBranch();
                        } else {
                            if ("new_ids" in result) {
                                result["new_ids"].forEach((ids) => {
                                    const savedRow = this.goodsData.find(
                                        (gd) => gd.id === ids["old_id"]
                                    );
                                    if (savedRow)
                                        this.$set(
                                            savedRow,
                                            "id",
                                            ids["new_id"]
                                        );
                                });
                            }
                            this.resetDecodes();

                            this.makeToast(
                                "success",
                                this.getErrText("msg"),
                                this.getErrText("saved")
                            );
                        }
                        if (!isSaveCat) this.loadCategoryData();
                    } else {
                        this.makeToast(
                            "danger",
                            this.getErrText("not_saved"),
                            "Error"
                        );
                    }
                } else {
                    this.makeToast(
                        "danger",
                        this.getErrText("not_saved"),
                        "Error:" + response.status
                    );
                }
            } catch (e) {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    e.toString()
                );
            } finally {
                this.selectAll = false;
                this.isLoad = false;
            }
        },

        resetDecodes() {
            this.goodsData.forEach((item) => {
                this.$set(item, "isNew", false);
                this.$set(item, "rowToSave", false);
                this.$set(item, "itemToDelete", false);
                this.$set(item, "isHasDouble", false);
                this.$set(item, "isDataValid", true);
            });
        },

        
        showEditModal(row, modalRef) {
            if (!row.type_credit) return;

            const modal = this.$refs[modalRef];
            if (modal) {
                this.isPeriodCanBeEmpty = modalRef === 'setPeriodModal' && !row.summa;
                modal.showModal(row);
            }
        },

        deleteItem(msg, row = false) {
            if (
                !this.variantAttribute ||
                this.isLoad ||
                (!row &&
                    this.budgetForm.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;

            if (row) this.currCategory = row.category_id;

            this.$bvModal
                .msgBoxConfirm(
                    this.getCommonText("del_with_decodes", { msg: msg }),
                    {
                        title: this.getCommonText("confirm"),
                        size: "lg",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: this.getCommonText("yes"),
                        cancelTitle: this.getCommonText("cancel"),
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        this.deletingCat = true;

                        if (row) {
                            if (row.id >= 0) {
                                this.deleteRows([row], "category");
                            } else {
                                const idxToDel = this.budgetForm.findIndex(
                                    (itm) => itm.id === row.id
                                );
                                this.budgetForm.splice(idxToDel, 1);
                                this.budgetFormTree = this.buildBudgetFormTree(this.budgetForm);
                            }
                        } else {
                            const existingRowsToDel = this.budgetForm.filter(
                                (item) => item.id >= 0 && item.itemToDelete
                            );
                            this.budgetForm = this.budgetForm.filter(item => !item.itemToDelete);
                            if (!existingRowsToDel.length) {
                                this.budgetFormTree = this.buildBudgetFormTree(this.budgetForm);
                                this.selectAll = false;
                            } else {
                                await this.deleteRows(
                                    existingRowsToDel,
                                    "category"
                                );
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        "danger",
                        this.getCommonText("on_del"),
                        error.toString()
                    );
                });
        },

        async loadGoodsData(cat) {
            this.isLoad = true;
            this.initialGoodsData = {};

            const newHeader = { ...this.header, cat_code: cat.category_id };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-goods/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(newHeader),
                    }
                );
                if (response.status === 200) {
                    const values = await response.json();

                    values.forEach((val) => {
                        this.$set(val, "isNew", false);
                        this.$set(val, "rowToSave", false);
                        this.$set(
                            val,
                            "curr_bc_goal",
                            this.getCurrBcGoal(val["bc_goal"])
                        );
                        this.$set(val, "itemToDelete", false);
                        this.$set(val, "isHasDouble", false);
                        this.$set(val, "isDataValid", true);

                        this.addGetParams(val);

                        this.initialGoodsData[val.id] = {
                            ...val,
                            total: val.total,
                        };
                    });
                    this.goodsData = values;

                    this.disableSelectedBcGlobal();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        }, // загрузка списка расшифровок

        getCurrBcGoal(bcGoal) {
            const curBcGoal = this.dictBcGlobal.find(
                (itm) => itm.code === bcGoal
            );
            return curBcGoal || null;
        },

        async deleteRows(items, mode) {
            this.isLoad = true;
            const data = {
                item: items,
                header: this.header,
                mode: mode,
                form: this.header.form,
            };
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form/",
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    const updateOnlyCategory = mode === "category";
                    await this.updateDatas(updateOnlyCategory);
                    this.makeToast(
                        "success",
                        this.getErrText("msg"),
                        this.getErrText("one_deleted")
                    );
                }
            } catch {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    this.getErrText("on_del")
                );
            }
            this.isLoad = false;
        }, // удаление данных

        getFiles(data) {
            this.files = data;
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            );
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        async loadCategoryData() {
            this.selectAll = false;
            this.isLoad = true;
            this.budgetForm.splice(0);
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-cat/" +
                        JSON.stringify(this.header)
                );
                if (response.ok) {
                    const values = await response.json();
                    values.forEach((val, i) => {
                        const item = { ...val };
                        this.$set(item, "newCat", false);
                        this.$set(item, "files", this.getUnicFilesArr(val));
                        this.$set(item, "checkForDuplicates", false);
                        this.$set(item, "itemToDelete", false);
                        const typeCreditObj = this.dictBcSection.find(
                            (dc) => dc.code === val.type_credit
                        );
                        this.$set(item, "typeCreditObj", typeCreditObj);
                        this.budgetForm.push(item);
                    });

                    this.budgetFormTree = this.buildBudgetFormTree(this.budgetForm);
                    this.disableSelectedBranch();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
        },

        async loadDict() {
            this.$set(this.header, 'form_version', this.form.code + '_v2')
            await Promise.all([
                this.getDictProjectBranch(),
                this.getDictBcSection(),
                this.getDictBcGlobal()
            ]);
        },

        buildBudgetFormTree(budgetForm) {
            const tree = budgetForm.reduce((acc, item) => {
                const branch = item.branch;
                const branchObj = this.dictProjectBranch.find(
                    (bp) => bp.code === branch
                );
                const summa = Number(item.summa) || 0;

                if (acc[branch]) {
                    acc[branch].items.push(item);
                    acc[branch].total += summa;
                    if (item.files && Array.isArray(item.files)) {
                        acc[branch].files = [...new Set([...acc[branch].files, ...item.files])];
                    }
                } else {
                    acc[branch] = {
                        id: `branch_${branch}`,
                        branch: branchObj,
                        items: [item],
                        total: summa,
                        itemToDelete: false,
                        files: item.files && Array.isArray(item.files) ? [...item.files] : [],
                        dictBcSectionActual: JSON.parse(JSON.stringify(this.dictBcSectionActual))
                    };
                }

                return acc;
            }, {});
            const treeArray = Object.values(tree);
            this.setDisabledItemsInDictBcSection(treeArray);
            return treeArray
        },

        setDisabledItemsInDictBcSection(treeArray) {
            treeArray.forEach(branchItem => {
                branchItem.dictBcSectionActual.forEach(creditTypeItem => {
                    const isCreditTypeSelected = branchItem.items.some(
                        (itm) => itm.type_credit === creditTypeItem.code
                    );
                    this.$set(creditTypeItem, "$isDisabled", isCreditTypeSelected);
                })
            });
            
        },

        async getDictProjectBranch() {
            try {
                const response = await fetch('/api-py/dict-project-branch-all');
                if (response.ok) {
                    this.dictProjectBranch = await response.json();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки справочника отраслей",
                    error.toString()
                );
            }
        },

        async getDictBcSection() {
            try {
                const response = await fetch('/api-py/dict-bc-section-all');
                if (response.ok) {
                    this.dictBcSection = await response.json();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки справочника разделов БК",
                    error.toString()
                );
            }
        },

        async getDictBcGlobal() {
            try {
                const response = await fetch('/api-py/dict-bc-goal-all');
                if (response.ok) {
                    this.dictBcGlobal = await response.json();
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки справочника целей БК",
                    error.toString()
                );
            }
        },
    
        prepareForSaveDecodes(event) {
            event.preventDefault();
            if (!this.goodsData.length || !this.variantAttribute) {
                this.makeToast(
                    "warning",
                    this.getErrText("msg"),
                    this.getErrText("not_saved")
                );
            }

            if (this.isDoubleDecodeExist()) {
                this.makeToast(
                    "warning",
                    this.getErrText("not_saved"),
                    this.getErrText("not_valid")
                );
                return;
            }
            const goodsTableFields = this.getValuesToSaveDecodes();
            
            
            const values = [];
            for (const row of this.goodsData) {
                if (this.isSavingForbidden(row, goodsTableFields, ['amount', 'cost'], ['bc_goal'])) return;

                if (!row.rowToSave) continue;
                values.push(row);
            }
            this.save(values);
        },

        getValuesToSaveDecodes() {
           return [
                    {
                        key: "bc_goal",
                        label: this.getCommonText("name"),
                    },
                    {
                        key: "amount",
                        label: this.getFormText("amount"),
                    },
                    {
                        key: "cost",
                        label: this.getFormText("one_item_cost"),
                    },
                ]
        },
    
        isDoubleDecodeExist() {
            const bcGoals = new Set();
            let isHasDouble = false;
            for (const item of this.goodsData) {
                if (bcGoals.has(item.bc_goal)) {
                    isHasDouble = true;
                    break;
                } else {
                    bcGoals.add(item.bc_goal);
                }
            }
            return isHasDouble;
        },
    
        disableSelectedBranch() {
            this.dictProjectBranchActualDisabled = this.dictProjectBranchActual.map((item) => {
                const isProjectBranchSelected = this.budgetFormTree.some(
                    (bf) => bf.branch && bf.branch.code === item.code
                );
                this.$set(item, "$isDisabled", isProjectBranchSelected);
                return item;
            });
        },

        disableSelectedBcGlobal() {
            this.dictBcGlobalActualDisabled = this.dictBcGlobalActual.map((item) => {
                const isBcGlobalSelected = this.goodsData.some(
                    (gd) => gd.bc_goal === item.code
                );
                this.$set(item, "$isDisabled", isBcGlobalSelected);
                return item;
            });
        },

        async delelteAttachedFileToCategory(file_name = null, file_type = null) {
            await this.delelteAttachedFile(file_name, file_type);
            this.budgetFormTree = this.buildBudgetFormTree(this.budgetForm);
        },

        isDecodeBtnDisabled(item) {
            return !(item.id > 0 && (item.period_ru || item.period_kk));
        },

        onCheckAllBranchClicked(e, branch) {
            branch.items.forEach((item) => {
                this.$set(item, 'itemToDelete', e);
            });
        },

        onCheckCreditTypeClicked(e, branch) {
            if (!e) {
                this.$set(branch, 'itemToDelete', e);
            } else {
                const allItemsSelected = branch.items.every((item) => item.itemToDelete);
                this.$set(branch, 'itemToDelete', allItemsSelected);
            }

            const allItemsSelected = this.budgetForm.every((item) => item.itemToDelete);
            this.selectAll = allItemsSelected;
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.summa);
            }
            return Math.ceil(sum);
        },

        dictProjectBranchActual() {
          return this.dictProjectBranch.filter(
                (item) => item.is_actual
            )
        },

        dictBcSectionActual() {
          return this.dictBcSection.filter(
                (item) => item.is_actual
            );
        },

        dictBcGlobalActual() {
          return this.dictBcGlobal.filter(
                (item) => item.is_actual
            )
        },
        
        isNotSavedBranchExist() {
            return this.budgetFormTree.some((item) => item.newBranch);
        },
        
        isNotSavedCreditType() {
            return this.budgetForm.some((item) => item.id < 0);
        },

        categoryName() {
            const localNameField =
                this.$i18n.locale === "kk" ? "name_kk" : "name_ru";
            return `${this.currCategory.branch_name}. ${this.currCategory.typeCreditObj[localNameField]}`;
        },

        getFormText() {
            return this.setFormText("forms_v2_common.");
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: "selection",
                        label: " ",
                    },
                    {
                        key: "name",
                        label: this.getCommonText("name"),
                    },
                    {
                        key: "period",
                        label: this.getFormText("implementation_period"),
                    },
                    {
                        key: "summa",
                        label: this.getFormText("summa"),
                    },
                    {
                        key: "recipient",
                        label: this.getFormText("recipient"),
                    },
                    {
                        key: "purpose",
                        label: this.getFormText("purpose"),
                    },
                    {
                        key: "justif",
                        label: this.getFormText("justification"),
                    },
                    {
                        key: "files",
                        label: this.getCommonText("files"),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
    },
};
</script>
<style scoped>
.filter-actions-flex {
    display: flex;
}

.table-plus {
    border: none;
}

.branch-row{
    height: auto;
    background-color: #E9F4FE;
    font-weight: bold !important;
}

.add-credit-type{
    cursor: pointer;
    color: #00a749;
    font-weight: 500;
    margin-top: 10px;
    text-decoration: underline;
}

.add-credit-type-row{
    background-color: #F7F9FC;
}

.total-table-row{
    font-weight: bold !important;
}

.table-plus-disabled {
    pointer-events: none;
    opacity: 0.3;
}

.goods-form-val-msg {
    font-size: 0.5rem;
    font-style: italic;
    color: red;
}

.bp-category-name {
    display: flex;
    justify-content: space-between;
}
</style>
